import { isTabbable } from './is-tabbable.js';

/**
 * Returns the last descendant of the container that the browser reaches when
 * pressing `Tab`, or `null` if there is none. Unlike `getLastFocusableChild`
 * this skips elements that are not rendered or that are inside an `inert`
 * subtree.
 *
 * @internal
 */
export function getLastTabbableChild(container: HTMLElement): Node | null {
  const treeWalker = document.createTreeWalker(container);

  // Move the current node to the last node of the container.
  while (treeWalker.lastChild()) {
    treeWalker.lastChild();
  }

  do {
    if (isTabbable(treeWalker.currentNode)) {
      return treeWalker.currentNode;
    }
  } while (treeWalker.previousNode());

  return null;
}
